const EMBED_PDF_SOURCE = 'https://cdn.jsdelivr.net/npm/@embedpdf/snippet@2.14.4/dist/embedpdf.js';

let embedPdfModulePromise;

const loadEmbedPdf = () => {
  if (!embedPdfModulePromise) {
    embedPdfModulePromise = import(EMBED_PDF_SOURCE).catch((error) => {
      embedPdfModulePromise = null;
      throw error;
    });
  }

  return embedPdfModulePromise;
};

const showNativeFallback = (viewer, error) => {
  const host = viewer.querySelector('[data-mphp-document-viewer-host]');
  const fallback = viewer.querySelector('[data-mphp-document-fallback]');
  const status = viewer.querySelector('[data-mphp-document-status]');

  if (host) host.hidden = true;
  if (fallback) {
    if (!fallback.src) fallback.src = fallback.dataset.src;
    fallback.hidden = false;
  }
  if (status) status.hidden = true;
  viewer.setAttribute('aria-busy', 'false');
  viewer.dataset.mphpDocumentViewerState = 'fallback';
  console.error('Maison document viewer failed to initialize.', error);
};

const initializeDocumentViewer = async (drawer) => {
  const viewer = drawer.querySelector('[data-mphp-document-viewer]');
  const host = viewer?.querySelector('[data-mphp-document-viewer-host]');
  const status = viewer?.querySelector('[data-mphp-document-status]');
  const documentUrl = viewer?.dataset.documentUrl;

  if (!viewer || !host || !documentUrl) return;
  if (['loading', 'ready', 'fallback'].includes(viewer.dataset.mphpDocumentViewerState)) return;

  viewer.dataset.mphpDocumentViewerState = 'loading';

  try {
    const { default: EmbedPDF, ZoomMode } = await loadEmbedPdf();
    if (!drawer.isConnected) return;

    EmbedPDF.init({
      type: 'container',
      target: host,
      src: documentUrl,
      tabBar: 'never',
      disabledCategories: [
        'annotation',
        'form',
        'redaction',
        'insert',
        'history',
        'document-open',
        'document-close',
        'document-capture',
        'document-protect',
        'panel',
      ],
      zoom: {
        defaultZoomLevel: ZoomMode.FitWidth,
        minZoom: 0.5,
        maxZoom: 3,
      },
      theme: {
        preference: 'light',
        light: {
          accent: {
            primary: '#252627',
            primaryHover: '#3b3d3e',
            primaryActive: '#111111',
            primaryLight: '#ececec',
            primaryForeground: '#ffffff',
          },
          background: {
            app: '#f2f2f2',
            surface: '#ffffff',
            surfaceAlt: '#f7f7f7',
            elevated: '#ffffff',
            input: '#ffffff',
          },
          border: {
            default: '#dedede',
            subtle: '#ededed',
            strong: '#252627',
          },
        },
      },
    });

    if (status) status.hidden = true;
    viewer.setAttribute('aria-busy', 'false');
    viewer.dataset.mphpDocumentViewerState = 'ready';
  } catch (error) {
    showNativeFallback(viewer, error);
  }
};

document.addEventListener('dialog:after-show', (event) => {
  const drawer = event.target;
  if (drawer instanceof HTMLElement && drawer.matches('[data-mphp-document-drawer]')) {
    initializeDocumentViewer(drawer);
  }
});

document.querySelectorAll('[data-mphp-document-drawer][open]').forEach(initializeDocumentViewer);
